module.exports = __webpack_public_path__ + "img/london-office-1.ab2e0e68.jpg";